import axios from "axios";
import { Toast } from "@/composables/Toast";

const { showToast } = Toast();

const AxiosChat = axios.create({
    baseURL: `${import.meta.env.VITE_APP_API_CHAT_SERVER_URL}/api/`,
});

AxiosChat.interceptors.request.use(
    (config) => {
        if (config.useRootBase) {
            config.baseURL = `${import.meta.env.VITE_APP_API_CHAT_SERVER_URL}/`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

AxiosChat.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 500 || error.response.status >= 500) {
            showToast("Error", "An internal server error occurred");
        }

        return Promise.reject(error);
    },
);

export default AxiosChat;
